import * as yup from "yup";

export const PAYMENT_CARD_FORM_SCHEMA = yup.object({
    checkbox: yup.string().required("This field is required"),
});

export const DEFAULT_VALUES = {
    checkbox: "",
};
